<template>
  <label class="bk-blokkli-item-options-checkbox">
    <input v-model="checked" type="checkbox" class="peer" />
    <div />
    <span>{{ label }}</span>
  </label>
</template>

<script setup>
import defineCommands from "#blokkli/helpers/composables/defineCommands";
import { computed, useBlokkli } from "#imports";
const { $t, state } = useBlokkli();
const props = defineProps({
  label: { type: String, required: true },
  property: { type: String, required: true },
  modelValue: { type: String, required: false }
});
const emit = defineEmits(["update:modelValue"]);
const checked = computed({
  get() {
    return props.modelValue === "1";
  },
  set(v) {
    emit("update:modelValue", v ? "1" : "0");
  }
});
defineCommands(() => {
  if (state.editMode.value !== "editing") {
    return;
  }
  return {
    id: "options:" + props.property + ":toggle",
    label: $t("optionsCommand.setOption", 'Set option "@option" to "@value"').replace("@option", props.label).replace("@value", checked.value ? "false" : "true"),
    group: "selection",
    icon: "form",
    callback: () => checked.value = !checked.value
  };
});
</script>

<script>
export default {
  name: "OptionsFormCheckbox"
};
</script>
